export const idbTheme = {
  palette: {
    primary: {
      main: "#005CFF",
      dark: "#005CFF",
      contrastText: "#fff",
    },
    secondary: {
      main: "#C62222",
      contrastText: "#fff",
    },
    text: {
      secondary: "#7E7E7E",
    },
  },
  typography: {
    fontFamily: "Aptos, sans-serif",
    button: {
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
        },
      },
    },
  },
};
